import React from "react";
import {
    List,
    Datagrid,
    TextField,
    BooleanField,
    NumberField,
    DateField,
    Show,
    SimpleShowLayout,
    FunctionField,
} from "react-admin";

const JsonBlock = ({ value }) => (
    <pre
        style={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            background: "#f6f6f6",
            padding: "12px",
            borderRadius: "8px",
            fontSize: "13px",
            lineHeight: 1.4,
        }}
    >
        {JSON.stringify(value ?? {}, null, 2)}
    </pre>
);

export const CompareRunList = () => (
    <List
        perPage={25}
        sort={{ field: "created_at", order: "DESC" }}
        title="Сравнения"
    >
        <Datagrid rowClick="show" bulkActionButtons={false}>
            <DateField source="created_at" label="Дата" showTime />
            <TextField source="username_snapshot" label="Пользователь" />
            <BooleanField source="success" label="Успешно" />
            <NumberField source="pdf_files_count" label="PDF" />
            <NumberField source="bank_count" label="Банков" />
            <NumberField source="result_rows_count" label="Строк" />
            <NumberField source="ok_count" label="ОК" />
            <NumberField source="difference_count" label="Разница" />
            <NumberField source="missing_in_1c_count" label="Нет в учете" />
            <NumberField source="missing_in_pdf_count" label="Нет в банке" />
            <NumberField source="duration_ms" label="Время, мс" />
        </Datagrid>
    </List>
);

export const CompareRunShow = () => (
    <Show title="Запуск сравнения">
        <SimpleShowLayout>
            <DateField source="created_at" label="Дата" showTime />
            <TextField source="username_snapshot" label="Пользователь" />
            <BooleanField source="success" label="Успешно" />
            <NumberField source="duration_ms" label="Время, мс" />
            <TextField source="error_message_short" label="Ошибка" />

            <NumberField source="pdf_files_count" label="Количество PDF" />
            <NumberField source="bank_count" label="Количество банков" />
            <NumberField source="unique_bin_count" label="Уникальных БИН" />
            <NumberField source="unique_gov_code_count" label="Уникальных кодов ГУ" />

            <NumberField source="result_rows_count" label="Строк результата" />
            <NumberField source="ok_count" label="ОК" />
            <NumberField source="difference_count" label="Разница" />
            <NumberField source="missing_in_1c_count" label="Нет в учете" />
            <NumberField source="missing_in_pdf_count" label="Нет в банке" />
            <NumberField source="account_mismatch_count" label="Ошибки по счетам" />
            <NumberField source="fio_mismatch_count" label="Ошибки по ФИО" />

            <FunctionField
                label="result_summary_json"
                render={(record) => <JsonBlock value={record?.result_summary_json} />}
            />
        </SimpleShowLayout>
    </Show>
);